import * as React from "react";
import Input from "../../Input-new/Input";
import UploadFiles from "./UploadFiles"

const items=[{
        label:'Rep Agreement',
        name:'rep_agreement_file_1'
        },{
        label:'Additional File 1',
        name:'rep_agreement_file_2'
        },{
        label:'Additional File 2',
        name:'rep_agreement_file_3'
        },{
        label:'Additional File 3',
        name:'rep_agreement_file_4'
        },{
        label:'Additional File 4',
        name:'rep_agreement_file_5'
        }];

const RepresentationAgreement = ({isAgent, data, handleChangeInput, handleChangeFile, viewMode, deleted}) => {
    return (
        <div className="Rep-agreement">
            <div className="Rep-agreement_column">
                <Input
                    className="Rep-agreement_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="listed_date"
                    label="Date Listed"
                    value={data.listed_date}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Rep-agreement_column_item"
                    type="text"
                    valueType="number"
                    name="expiration_no_of_months"
                    label="# Of Months"
                    value={data.expiration_no_of_months}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Rep-agreement_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="expiration_date"
                    label="Listing Expiration Date"
                    value={data.expiration_date}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Rep-agreement_column_item"
                    type="text"
                    valueType="percent"
                    name="seller_fee_percentage"
                    label="Fee Percentage"
                    value={data.seller_fee_percentage}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="Rep-agreement_column_item"
                    disabled
                    type="text"
                    valueType="float"
                    name="total_fee"
                    label="Total Fee - Auto"
                    value={data.total_fee}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
            </div>
            <div className="Rep-agreement_column">
                <UploadFiles 
                    classNames="Rep-agreement_column_item"
                    data={data}
                    viewMode={viewMode} 
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    maxFilesAmount={items.length}
                    items={items}
                    disabled={isAgent}/>
            </div>
        </div>
    );
};

export default RepresentationAgreement;
